/**
 * Represents the currently signed-in user after successful token validation.
 *
 * Populated from the JWT claims and Microsoft Graph profile fields. All optional
 * profile fields default to empty strings when not present in the token.
 */
export class AuthenticatedUser {
  constructor(
    public readonly id: string,
    public readonly email: string,
    public readonly firstName: string,
    public readonly lastName: string,
    public readonly jobTitle: string = '',
    public readonly department: string = '',
    public readonly companyName: string = '',
    public readonly officeLocation: string = '',
    public readonly employeeType: string = '',
    public readonly managerName: string = '',
    public readonly assumedRole: string = 'EMPLOYEE',
    public readonly functionalGroups: readonly string[] = [],
  ) {}

  /** Return the user's full name, or email when first/last name are both empty. */
  getDisplayName(): string {
    const fullName = `${this.firstName} ${this.lastName}`.trim();
    return fullName || this.email;
  }
}
